import CalculatedMetrics from "@panel/calculated-metrics";
import ChurnReport from "@panel/reports/churn";
import Companies from "@panel/companies";
import CompanyDetails from "@panel/companies/tabs/companies/details";
import Dashboard from "@panel/dashboard";
import HealthScores from "@panel/health-scores";
import Invoices from "@panel/settings/invoices";
import Lifecycle from "@panel/life-cycle";
import MyAccount from "@panel/settings/accounts";
import OnboardingWonReport from "@panel/reports/onboarding-won";
import Platforms from "@panel/platforms";
import Playbook from "@panel/playbook";
import RetentionReport from "@panel/reports/retention";
import RevenueReport from "@panel/reports/revenue";
import Segments from "@panel/segment";
import Subscriptions from "@panel/settings/subscriptions";
import SurveyResponse from "@panel/surveys/response";
import Surveys from "@panel/surveys";
import Tags from "@panel/settings/tags";
import TeamPerformanceReport from "@panel/reports/team-performance";
import Users from "@panel/users";
import Plans from "@panel/plans";
import ApiKey from "@src/views/panel/settings/apikey";
import { Templates } from "@src/views/panel/settings/templates";
import DynamicStages from "@src/views/panel/settings/stages";
import Organizations from "@src/views/panel/organizations";
import CustomFields from "@src/views/panel/custom-fields";
import Kpi from "@src/views/panel/settings/kpi";

const PanelRoutes = [
    {
        path   : "/superadmin/organizations",
        element: <Organizations />,
        meta   : {
            resource: "organizations",
            title   : "Organizations",
            action  : "read"
        }
    },

    // Dashboard Routes
    {
        path   : "/dashboard/:platformId",
        element: <Dashboard />,
        meta   : {
            resource: "dashboard",
            title   : "Dashboard",
            action  : "read"
        }
    },
    // Reports Routes
    {
        path   : "/product/:platformId/reports/team-performance",
        element: <TeamPerformanceReport />,
        meta   : {
            resource: "reports",
            title   : "Team Performance Report",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/reports/revenue",
        element: <RevenueReport />,
        meta   : {
            resource: "reports",
            title   : "Revenue Report",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/reports/retention",
        element: <RetentionReport />,
        meta   : {
            resource: "reports",
            title   : "Retention Report",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/reports/churn",
        element: <ChurnReport />,
        meta   : {
            resource: "reports",
            title   : "Churn Report",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/reports/onboarding-won",
        element: <OnboardingWonReport />,
        meta   : {
            resource: "reports",
            title   : "Onboarding Report"
        }
    },
    // Segment Routes
    {
        path   : "/product/:platformId/segments",
        element: <Segments />,
        meta   : {
            resource: "segments",
            title   : "Segments",
            action  : "read"
        }
    },
    // Life Cycle Routes
    {
        path   : "/product/:platformId/life-cycle",
        element: <Lifecycle />,
        meta   : {
            resource: "life-cycle",
            title   : "Life Cycle",
            action  : "read"
        }
    },
    // Platform Routes
    {
        path   : "/platforms",
        element: <Platforms />,
        meta   : {
            resource: "platforms",
            title   : "Product",
            action  : "read"
        }
    },
    // Health Scores Routes
    {
        path   : "/product/:platformId/health-scores",
        element: <HealthScores />,
        meta   : {
            resource: "health-scores",
            title   : "Health Scores",
            action  : "read"
        }
    },
    // Calculated Metrics Routes
    {
        path   : "/product/:platformId/calculated-metrics",
        element: <CalculatedMetrics />,
        meta   : {
            resource: "calculated-metrics",
            title   : "Calculated Metrics",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/custom-fields",
        element: <CustomFields />,
        meta   : {
            resource: "custom-fields",
            title   : "Custom Fields",
            action  : "read"
        }
    },
    // Settings Routes
    {
        path   : "/product/:platformId/settings/stages",
        element: <DynamicStages />,
        meta   : {
            resource: "settings",
            title   : "Stages",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/settings/subscriptions",
        element: <Subscriptions />,
        meta   : {
            resource: "settings",
            title   : "Subscriptions",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/settings/templates",
        element: <Templates />,
        meta   : {
            resource: "settings",
            title   : "Templates",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/settings/invoices",
        element: <Invoices />,
        meta   : {
            resource: "settings",
            title   : "Invoices",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/settings/tags",
        element: <Tags />,
        meta   : {
            resource: "settings",
            title   : "Tags",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/settings/kpi",
        element: <Kpi />,
        meta   : {
            resource: "settings",
            title   : "KPI",
            action  : "read"
        }
    },
    {
        path   : "/settings/apikey",
        element: <ApiKey />,
        meta   : {
            resource: "settings",
            title   : "API Key",
            action  : "read"
        }
    },
    {
        path   : "*",
        element: <Dashboard />,
        meta   : {
            resource: "dashboard",
            title   : "Dashboard",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/companies",
        element: <Companies />,
        meta   : {
            resource: "companies",
            title   : "Companies",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/companies/:clientId",
        element: <CompanyDetails />,
        meta   : {
            resource: "companies",
            title   : "Companies-Details",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/life-cycle",
        element: <Lifecycle />,
        meta   : {
            resource: "life-cycle",
            title   : "Life Cycle",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/plans",
        element: <Plans />,
        meta   : {
            resource: "plans",
            title   : "Plans",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/playbooks",
        element: <Playbook />,
        meta   : {
            resource: "playbooks",
            title   : "Playbooks",
            action  : "read"
        }
    },
    {
        path   : "/product/:platformId/surveys",
        element: <Surveys />,
        meta   : {
            resource: "surveys",
            title   : "Surveys",
            action  : "read"
        }
    },
    {
        path   : "/survey/response/:survey_id",
        element: <SurveyResponse />,
        meta   : {
            resource: "surveys",
            title   : "Surveys Response",
            action  : "read"
        }
    },
    {
        path   : "/account/users",
        element: <Users />,
        meta   : {
            resource: "users",
            title   : "Users",
            action  : "read"
        }
    },
    {
        path   : "/account/platforms",
        element: <Platforms />,
        meta   : {
            resource: "platforms",
            title   : "Products",
            action  : "read"
        }
    },
    {
        path   : "/account/myaccount",
        element: <MyAccount />,
        meta   : {
            resource: "settings",
            title   : "My Account",
            action  : "read"
        }
    }
];

export default PanelRoutes;
